import React from 'react';
import { Icon, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { FuseUtils } from '@fuse';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from 'app/store/actions';
import FuseNavBadge from './../FuseNavBadge';
import { useIntl } from 'react-intl';
import { localizedItem } from '../localizedMenu';
import { useIsInLimboPeriod, useIsPlacePendingActivateHasAccess } from 'app/auth/authHooks';
import { useIsPlaceRestricted } from 'commons/useIsPlaceRestricted';
import {  openDialog } from 'app/auth/store/actions/createNotification.actions';
import { useNotifications } from 'app/main/messages/notificationTimeline/useNotifications';
import * as R from 'ramda';
import {ACTION_NEW, GENERAL_DIALOG} from 'app/constants/compose'

const useStyles = makeStyles(theme => ({
  item: {
    height: 40,
    width: 'calc(100% - 12px)',
    borderRadius: '0 20px 20px 0',
    paddingRight: 12,
    '&.active': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText + '!important',
      pointerEvents: 'none',
      transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
      '& img': {
        backgroundColor: theme.palette.secondary.contrastText,
      },
      '& .list-item-text-primary': {
        color: 'inherit',
      },
      '& .list-item-icon': {
        color: 'inherit',
      },
    },
    '&.active .custom-icon': {
      backgroundColor: 'transparent',
      filter:
        'invert(100%) sepia(0%) saturate(0%) hue-rotate(299deg) brightness(200%) contrast(101%);',
    },
    '& .custom-icon': {
      backgroundColor: 'inherit',
    },
    '&.square, &.active.square': {
      width: '100%',
      borderRadius: '0',
    },
    '& .list-item-icon': {},
    '& .list-item-text': {},
    color: theme.palette.text.primary,
    cursor: 'pointer',
    textDecoration: 'none!important',
  },
  mainColorIcon: {
    color: theme.palette.secondary.main,
  },
}));

function FuseNavVerticalButton(props) {
  const dispatch = useDispatch();
  const userRole = useSelector(({ auth }) => auth.user.role);
  const direction = useSelector(({ fuse }) => fuse.settings.defaults.direction);
  const isInLimboPeriod = useIsInLimboPeriod();
  const isPlaceRestricted = useIsPlaceRestricted();

  const [{ refetchNotifications }] = useNotifications();

  const onOpenCreateNotificationDialog = () => {
    dispatch(
      openDialog({ 
        initialValues:undefined,     
        onCreateSuccess: refetchNotifications,
        type:GENERAL_DIALOG,
        action:ACTION_NEW
      })
    );
  };

  const classes = useStyles(props);
  const { item = {}, nestedLevel, active } = props;
  let paddingValue = 24 + nestedLevel * 16;
  const paddingPrefix = direction === 'rtl' ? 'pr-' : 'pl-';
  const listItemPadding =
    nestedLevel > 0
      ? paddingPrefix + (paddingValue > 60 ? 60 : paddingValue)
      : paddingPrefix + '24';

  const { formatMessage } = useIntl();
  const isPendingActiveMenu = useIsPlacePendingActivateHasAccess();

  if (!FuseUtils.hasPermission(item.auth, userRole) || R.prop('hidden', item)) {
    return null;
  }

  return (
    <ListItem
      button
      component="button"
      className={clsx(classes.item, listItemPadding, 'list-item', active, 'subMenuSidebarMenu')}
      disabled={isPendingActiveMenu || isInLimboPeriod || isPlaceRestricted}
      onClick={() => {
        dispatch(Actions.navbarCloseMobile());
        onOpenCreateNotificationDialog();
      }}
      exact={item.exact}
    >
      {item.icon && (
        <Icon
          className={clsx(
            classes.mainColorIcon,
            'list-item-icon text-16 flex-shrink-0 ltr:mr-16 rtl:ml-16'
          )}
        >
          {item.icon}
        </Icon>
      )}
      {item.iconImage && (
        <img
          alt="logo"
          className={clsx(classes.mainColorIcon, 'list-item-img text-16 flex-shrink-0 ltr:mr-16')}
          src={item.iconImage}
        />
      )}
      {item.customIcon && (
        <img
          alt="logo"
          className={clsx(
            classes.mainColorIcon,
            'list-item-img text-16 flex-shrink-0 ltr:mr-16 custom-icon'
          )}
          src={item.customIcon}
        />
      )}
      <ListItemText
        className="list-item-text"
        primary={localizedItem(item, formatMessage)}
        classes={{ primary: 'text-14 list-item-text-primary' }}
      />
      {item.badge && <FuseNavBadge badge={item.badge} />}
    </ListItem>
  );
}

FuseNavVerticalButton.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    localizedId: PropTypes.string,
  }),
};

const NavVerticalItem = withRouter(React.memo(FuseNavVerticalButton));

export default NavVerticalItem;
